import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

import TimesheetStructureTips from "presentation/pages/timesheet-structures/elements/timesheet-structure-tips";
import RemoveAction from "presentation/components/remove-action";

import AddButton from "presentation/components/buttons/add";

import {
    changeTimesheetStructureItemsList,
    handleChangeTimesheetStructureItems,
    timesheetStructureItemsFormValue,
    mountItems
} from 'presentation/pages/timesheet-structures/functions/timesheet-structure-items';

class TimesheetStrcutureItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    addOption = () => {
        let { component } = this.props;
        let { totalItems } = component.state;
        component.setState({ ...component.state, totalItems: totalItems + 1 }, () => mountItems(component));
    }

    removeAction = (key) => {
        let { component } = this.props;

        let { totalItems } = component.state;

        let timesheetStructureItems = changeTimesheetStructureItemsList(component, { key: key }, true);

        //reorganiza as keys
        let index = 0;
        timesheetStructureItems.map((element, i) => {
            if (!element.isDeleteRequested) {
                element.key = index + 1;
                index++;
            }
            return element;
        });

        component.setState({ ...component.state, totalItems: totalItems - 1, timesheetStructureItems: timesheetStructureItems }, () => mountItems(component));
    }

    render() {
        let { component } = this.props;
        const { timesheetStructureItems, loading, totalItems, form } = component.state;

        const { addOption, removeAction } = this;

        const validTimesheetStructureItems = timesheetStructureItems.filter(x => !x.isDeleteRequested);

        return (
            <div>
                <h5 className="mt-4">Tempos de atividade</h5>
                <table className="table table-borderless">
                    <thead>
                        <tr>
                            <th width="33%">Nomenclatura</th>
                            <th className="text-end" width="33%">Duração (em minutos)</th>
                            <th width="34%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {validTimesheetStructureItems.map((element, index) => {
                            let key = element.key;

                            let nameValue = timesheetStructureItemsFormValue(key, 'name', component);
                            let durationInMinutesValue = timesheetStructureItemsFormValue(key, 'durationInMinutes', component);
                            const deleteIsDisabled = totalItems < 2;
                            return (
                                <tr key={`timesheet-structure-item-${key}`}>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            id={`name-${key}`}
                                            name={`name-${key}`}
                                            data-field-name="name"
                                            defaultValue={nameValue || ""}
                                            onChange={(event) => handleChangeTimesheetStructureItems(key, event, component)}
                                        />
                                    </td>
                                    <td className="float-end">
                                        <Form.Control
                                            type="number"
                                            id={`durantion-in-minutes-${key}`}
                                            name={`duration-in-minutes-${key}`}
                                            data-field-name="durationInMinutes"
                                            defaultValue={durationInMinutesValue || undefined}
                                            onChange={(event) => handleChangeTimesheetStructureItems(key, event, component)}
                                        />
                                    </td>
                                    <td>
                                        <RemoveAction
                                            className="float-end"
                                            component={this}
                                            optionKey={key}
                                            loading={loading}
                                            deleteIsDisabled={deleteIsDisabled}
                                            removeAction={removeAction} />
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan={3}>
                                <div className="text-end">
                                    <AddButton
                                        containerProps={{
                                            onClick: addOption,
                                            variant: 'success',
                                            className: 'mt-1 mb-1'

                                        }}
                                        title='Adicionar tempo'
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <TimesheetStructureTips component={this} form={form} />
            </div>
        );
    };
}

export default TimesheetStrcutureItems;